import { size, truncate } from 'lodash/fp';
import { UnicodeEntity } from '@mews/enums';

const MAX_NAME_LENGTH = 30;
const OMISSION_STRING = UnicodeEntity.Ellipsis;

interface TruncatedEntityNameProps {
    name: string;
    maxNameLength?: number;
    omission?: string;
    shortName?: string;
}

export const TruncatedEntityName = ({
    name,
    maxNameLength = MAX_NAME_LENGTH,
    omission = OMISSION_STRING,
    shortName,
}: TruncatedEntityNameProps) => {
    const shouldTruncate = size(name) > maxNameLength;
    const shortenedName = shouldTruncate
        ? truncate({ length: maxNameLength - size(omission), omission }, shortName || name)
        : name;

    return <span>{shortenedName}</span>;
};
